import { PayloadAction } from '@reduxjs/toolkit';
import { fetchEvent } from 'app/pages/EventDetailsPage/slice';
import { fetchEventWithTickets } from 'app/pages/TicketSalePage/slice';
import { createSagaAction } from 'saga-toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { VendorPublicInformation, VendorState } from './types';

const sliceName = 'vendor';

const initialPublicInformation = {
  name: '',
  avatar: '',
  description: '',
};

export const initialState: VendorState = {
  isLoading: false,
  id: '',
  gtm_code: '',
  merchantTaxName: '',
  features: {
    hasMarketplaceCustomLogo: false,
    hideFooter: false,
    hasEnabledPO: false,
    byDefaultOpenCompanyTab: false,
    hasAISalesAgent: false,
    displayCalendarInsidePageLayout: false,
    hasIdMeImplementation: false,
  },
  publicInformation: initialPublicInformation,
};

const vendor = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setVendorData: (
      state,
      action: PayloadAction<{
        isLoading?: boolean;
        id: string;
        features: {
          hasMarketplaceCustomLogo: boolean;
          hideFooter: boolean;
          hasEnabledPO?: boolean;
          byDefaultOpenCompanyTab?: boolean;
        };
        publicInformation: VendorPublicInformation;
      }>,
    ) => {
      const {
        isLoading = false,
        id,
        features,
        publicInformation,
      } = action.payload;
      state.isLoading = isLoading;
      state.id = id;
      for (let feature in features) {
        state.features[feature] = features[feature];
      }
      if (publicInformation) {
        state.publicInformation = { ...publicInformation };
      } else {
        const getInitialPublicInformation = () => initialPublicInformation;
        state.publicInformation = getInitialPublicInformation();
      }
    },
    setMerchantTaxName: (state, action: PayloadAction<string>) => {
      state.merchantTaxName = action.payload;
    },
  },
  extraReducers: {
    [fetchEvent.fulfilled]: (_, action) => {
      const { id_seller, gtm_code, sellerFeatures, seller_public_information } =
        action.payload;
      return {
        isLoading: false,
        id: id_seller,
        gtm_code,
        merchantTaxName: '',
        features: { ...sellerFeatures },
        publicInformation: { ...seller_public_information },
      };
    },
    [fetchEventWithTickets.fulfilled]: (state, action) => {
      const {
        id_seller,
        gtm_code,
        sellerFeatures,
        seller_public_information,
        merchantTaxName,
      } = action.payload;
      return {
        isLoading: false,
        id: id_seller,
        gtm_code: gtm_code,
        merchantTaxName,
        features: { ...sellerFeatures },
        publicInformation: { ...seller_public_information },
      };
    },
  },
});

export const {
  actions: { setVendorData, setMerchantTaxName },
} = vendor;

export default vendor.reducer;
